import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Register from "./components/Register";
import Login from "./components/Login";
import Home from "./components/Home";
import Enquiry from "./components/Enquiry";
import VendorRejectionAgent from "./components/VendorRejectionAgent";
import SupplyChainAgent from "./components/SupplyChainAgent";
import AutomatedQuotationAgent from "./components/AutomatedQuotationAgent";
import "react-toastify/dist/ReactToastify.css";
import "animate.css";
import WatsonChat from "./components/WatsonChat";
import WatsonOrchestrateAgent from "./components/WatsonOrchestrateAgent";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Privacy from "./components/PrivacyPolicy";
import InvoiceAnalysisTool from "./components/InvoiceAnalysisTool";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import InvoiceInfo from "./components/InvoiceInfo";
import KnowYourCost from "./components/KnowYourCost";

function AppContent({ token, setToken }) {
  const location = useLocation();
  const hideLayout = ["/enquiry","/VendorRejectionAgent","/SupplyChainAgent","/AutomatedQuotationAgent"].includes(location.pathname);
  const isEnquiryPage = location.pathname === "/enquiry";

  return (
    <div>
      {!hideLayout &&  <WatsonChat setToken={setToken} /> }
      {/* {isEnquiryPage && <WatsonOrchestrateAgent setToken={setToken} />} */}
      {!hideLayout && <Nav setToken={setToken} />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login setToken={setToken} />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/know-your-cost" element={<KnowYourCost />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/vendorrejectionagent" element={<VendorRejectionAgent />} />
        <Route path="/supplychainagent" element={<SupplyChainAgent />} />
        <Route path="/automatedquotationagent" element={<AutomatedQuotationAgent />} />
        <Route
          path="/invoice"
          element={token ? <InvoiceAnalysisTool /> : <InvoiceInfo />}
        />
      </Routes>

      {!hideLayout && <Footer />}
    </div>
  );
}

function App() {
  const [token, setToken] = useState(sessionStorage.getItem("token"));

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken !== token) {
      setToken(storedToken);
    }
  }, [token]);

  return (
    <Router>
      <AppContent token={token} setToken={setToken} />
    </Router>
  );
}

export default App;
